import { ComponentType } from "react";
import { PersonAgeFragment } from "gql/graphql";
import { Hidable, NotSpecified, Value } from "@/shared/value";

/**
 * Возраст человека. Бэкенд считает его сам по дате рождения, поэтому на месте показа
 * возраст не вычисляется — но и не подставляется числом мимо пустого значения.
 */
export function PersonAge({
  data,
  whenEmpty: WhenEmpty = NotSpecified,
}: {
  data?: Hidable<PersonAgeFragment>;
  whenEmpty?: ComponentType;
}) {
  return (
    <Value data={data} whenEmpty={WhenEmpty}>
      {(person) =>
        person.age === null || person.age === undefined ? (
          <WhenEmpty />
        ) : (
          <span>{person.age}</span>
        )
      }
    </Value>
  );
}
